//Action Creators for Analyitcs Site
import axios from 'axios';
//import baseApi from '../apis/approvalsApi';


const activeUsersTestList = [
    {
        "email": "Spencer.Wright@intusurg.com",
        "name": "Spencer Wright",
        "type": "top20",
        "totalClickCount": 2283
    },
    {
        "email": "Alicia.Hyland@intusurg.com",
        "name": "Alicia Hyland",
        "type": "top20",
        "totalClickCount": 556
    },
    {
        "email": "Quy.Tran@intusurg.com",
        "name": "Quy Tran",
        "type": "top20",
        "totalClickCount": 305
    },
    {
        "email": "Killian.Magee@intusurg.com",
        "name": "Killian Magee",
        "type": "top20",
        "totalClickCount": 290
    },
    {
        "email": "Ryan.Harrington@intusurg.com",
        "name": "Ryan Harrington",
        "type": "top20",
        "totalClickCount": 233
    },
    {
        "email": "Ian.Elmazaj@intusurg.com",
        "name": "Ian Elmazaj",
        "type": "top20",
        "totalClickCount": 171
    },
    {
        "email": "Mike.Prindiville@intusurg.com",
        "name": "Mike Prindiville",
        "type": "top20",
        "totalClickCount": 153
    },
    {
        "email": "Victor.Valdez@intusurg.com",
        "name": "Victor Valdez",
        "type": "top20",
        "totalClickCount": 141
    },
    {
        "email": "Nehmya.Adere@intusurg.com",
        "name": "Nehmya Adere",
        "type": "top20",
        "totalClickCount": 140
    },
    {
        "email": "Yasser.Abdin@intusurg.com",
        "name": "Yasser Abdin",
        "type": "top20",
        "totalClickCount": 120
    },
    {
        "email": "Ryan.santos@intusurg.com",
        "name": "Ryan Santos",
        "type": "top20",
        "totalClickCount": 116
    },
    {
        "email": "Kevin.Crawford@intusurg.com",
        "name": "Kevin Crawford",
        "type": "top20",
        "totalClickCount": 114
    },
    {
        "email": "Eduardo.Villanueva@intusurg.com",
        "name": "Eduardo Villanueva",
        "type": "top20",
        "totalClickCount": 114
    },
    {
        "email": "Alejandra.Erbe@intusurg.com",
        "name": "Alejandra Erbe",
        "type": "top20",
        "totalClickCount": 113
    },
    {
        "email": "David.Robinson@intusurg.com",
        "name": "David Robinson",
        "type": "top20",
        "totalClickCount": 108
    },
    {
        "email": "Dorothy.Hwang@intusurg.com",
        "name": "Dorothy Hwang",
        "type": "top20",
        "totalClickCount": 107
    },
    {
        "email": "Cindy.Salas@intusurg.com",
        "name": "Cindy Salas",
        "type": "top20",
        "totalClickCount": 102
    },
    {
        "email": "Carlos.Aguirre@intusurg.com",
        "name": "Carlos Aguirre",
        "type": "top20",
        "totalClickCount": 98
    },
    {
        "email": "Maria.Velazquez@intusurg.com",
        "name": "Elena Velazquez",
        "type": "top20",
        "totalClickCount": 97
    },
    {
        "email": "Beto.HernandezAdame@intusurg.com",
        "name": "Beto Hernandez Adame",
        "type": "top20",
        "totalClickCount": 97
    },
    {
        "email": "Tim.Limon@intusurg.com",
        "name": "Tim Limon",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Lisa.Lenaway@intusurg.com",
        "name": "Lisa Lenaway",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Alejandro.Figueroa@intusurg.com",
        "name": "Alejandro Figueroa",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Jesus.Flores@intusurg.com",
        "name": "Jesus Flores",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Jack.Hudson@intusurg.com",
        "name": "Jack Hudson",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Raj.Maniar@intusurg.com",
        "name": "Raj Maniar",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Joshua.Harris@intusurg.com",
        "name": "Joshua Harris",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Sandeep.kaur@intusurg.com",
        "name": "Sandeep Kaur",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Marc.Levesque@intusurg.com",
        "name": "Marc Levesque",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "RobertXinsheng.Chen@intusurg.com",
        "name": "Robert Xinsheng Chen",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Alexander.Grosch@intusurg.com",
        "name": "Alexander Grosch",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Anthony.Lin@intusurg.com",
        "name": "Anthony Lin",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Kathya.Ortiz@intusurg.com",
        "name": "Kathya Ortiz",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Dennise.DalmaWeiszhausz@intusurg.com",
        "name": "Dennise Dalma Weiszhausz",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "LUIS.LERMA@intusurg.com",
        "name": "LUIS LERMA",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Rajalekha.M.Rajamahendiran@intusurg.com",
        "name": "Rajalekha Manjakuppam Rajamahendiran",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Miriam.DeLaCruz@intusurg.com",
        "name": "Miriam De La Cruz",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Janine.Fallon@intusurg.com",
        "name": "Janine Fallon",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Jonathan.Arrescurrenaga@intusurg.com",
        "name": "Jonathan Arrescurrenaga",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Marco.Tran@intusurg.com",
        "name": "Marco Tran",
        "type": "middle20",
        "totalClickCount": 4
    },
    {
        "email": "Douglas.Phan@intusurg.com",
        "name": "Douglas Phan",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Victor.Rivera2@intusurg.com",
        "name": "Victor Rivera",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Tina.Nguyen@intusurg.com",
        "name": "Tina Nguyen",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Enrico.Veloria@intusurg.com",
        "name": "Enrico Veloria",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Tim.Huang@intusurg.com",
        "name": "Tim Huang",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Jiyeon.Shin@intusurg.com",
        "name": "Jiyeon Shin",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Sebastian.Gretzmeier@intusurg.com",
        "name": "Sebastian Gretzmeier",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "PoliReddy.Reddem@intusurg.com",
        "name": "Poli Reddy Reddem",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Avinash.Uppuluri@intusurg.com",
        "name": "Avinash Uppuluri",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Liang.Xue@intusurg.com",
        "name": "Liang Xue",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Adalberto.Zamora@intusurg.com",
        "name": "Adalberto Zamora",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Ryohei.Fujitsuka@intusurg.com",
        "name": "Ryohei Fujitsuka",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Amarjeet.Ghatoura@intusurg.com",
        "name": "Amarjeet Ghatoura",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Han.Nguyen@intusurg.com",
        "name": "Han Nguyen",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Mittali.Daiya@intusurg.com",
        "name": "Mittali Daiya",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Brett.Beauchamp-Russell@intusurg.com",
        "name": "Brett Beauchamp-Russell",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "aruna.krishnan@intusurg.com",
        "name": "Aruna Krishnan",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Yunyi.Cai@intusurg.com",
        "name": "Yunyi Cai",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Chhakda.Reth@intusurg.com",
        "name": "Chhakda Reth",
        "type": "bottom20",
        "totalClickCount": 1
    },
    {
        "email": "Michael.Baldwin@intusurg.com",
        "name": "Michael Baldwin",
        "type": "bottom20",
        "totalClickCount": 1
    }
];

export const mostActiveUsersListFilterSelected = (filter) => {
    //return an action
    return {
        type: 'ACTIVE_USERS_LIST_FILTER_SELECTED',
        payload: filter
    };
};


//initial function to get data
export const fetchActiveUsersListData = (userToken) => async dispatch => {
    //start loading spinner
    dispatch({ type: 'ACTIVE_USERS_LIST_IS_LOADING' });

    //API Call
    let activerUsersList = await getDataCall(userToken);
    //activerUsersList = activeUsersTestList; //for UAT 

    //let cleanActiveData = await cleanUpData(avgsData);

    console.log("Most Active Users data cleaned: ", activerUsersList);



    //get all data & store in state
    // yearCountFinal: result,
    //     dailyCountFinal: dailyCounts


    dispatch({ type: 'FETCH_ACTIVE_USERS_LIST_DATA', payload: activerUsersList });
    dispatch({ type: 'ACTIVE_USERS_LIST_IS_READY' });
};

//remove any 0's , remove apps to not show like ISU
const cleanUpData = async (avgsData) => {

    avgsData.approvalTimes1Day = avgsData.approvalTimes1Day.filter(obj => obj.totalAverageTimeToApprove !== 0 && obj.appName !== "ISU");
    //console.log("TEST CLEAN AVGS: ", avgsData.approvalTimes1Day);

    avgsData.approvalTimes30Days = avgsData.approvalTimes30Days.filter(obj => obj.totalAverageTimeToApprove !== 0 && obj.appName !== 'ISU');
    // avgsData = avgsData.approvalTimes30Days.filter(obj => obj.appName !== 'ISU');

    avgsData.approvalTimes180Days = avgsData.approvalTimes180Days.filter(obj => obj.totalAverageTimeToApprove !== 0 && obj.appName !== 'ISU');
    //avgsData = avgsData.approvalTimes180Days.filter(obj => obj.appName !== 'ISU');

    return avgsData;
}


//API Call to get averages
const getDataCall = async (curToken) => {
    try {

        // Define the base URL and endpoint

        const baseUrl = process.env.REACT_APP_BASE_URL + "/Analytics/ActiveUsers";

        // Define headers
        const headers = {
            'Authorization': 'Bearer ' + curToken.accessToken,
        };

        // Define query parameters
        const params = {
            platform: 'desktop'
        };

        // Make GET request 
        const response = await axios.get(baseUrl, {
            headers: headers,
            params: params
        });

        console.log("Active users API Response:", response.data);
        return response.data;
        //dispatch({ type: 'ANALYTICS_ACCESS', payload: dataObj.analyticsAccess });
    } catch (error) {
        // Handle any errors
        console.log("Error getting Active Users list from API:");
        return [];
    }
}
